export default {
    push(callback){
        if (!window.allowEdrone) {
            return;
        }
        if (typeof _edrone == "undefined") {
            return;
        }
        try {
            callback(_edrone);
        } catch (e) {
            console.log("edrone exception");
            if (typeof Raven != "undefined" && Raven.captureException) {
                Raven.captureException(e);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/edrone.js